var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(_vm.isAuthenticanting)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loader"})]):(_vm.isAuthenticated || _vm.isUnauthenticated)?_c('div',{staticClass:"router-view"},[_c('router-view')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }